import Header from './Header';

export default Header;
// temporary header untill route fix
